import { clientPath, lpRequest } from '../../../../core/utils/lp-backend';
import { byName } from '../../../branches/data/datasources/branch-shape';

/** `GET /client/:cid/regions/:id` answers `hub_ids`; cb answered the hubs, so they are read from the hub list. */
export const getRegion = async (region_id: string): Promise<any> => {
  const [region, hubs] = await Promise.all([
    lpRequest('GET', clientPath(`/regions/${region_id}`)),
    lpRequest('GET', clientPath('/hubs'))
  ]);
  const hub_ids: string[] = region.hub_ids || [];

  return {
    ...region,
    hub_ids,
    hubs: (hubs || []).filter((hub: any) => hub_ids.includes(hub.id)).sort(byName)
  };
};
